import { render, staticRenderFns } from "./HelpCenterEdit.vue?vue&type=template&id=3368c967&"
import script from "./HelpCenterEdit.vue?vue&type=script&lang=js&"
export * from "./HelpCenterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports